export default __webpack_public_path__ + "static/Sanaa-5ccbc43a6aebd2894fc7aecdae65d1dc.jpeg";